// This function validate frame number with the pattern
// 1. Start with "EFY" or "XNP".
// 2. Optionally have exactly two uppercase letters.
// 3. End with one or more digits or uppercase letters.
export const validateFramenumber = (value: string) => {
    const regex = new RegExp('^(?:EFY|XNP|MAX)(?:[A-Z]{2})?[0-9A-Z]+$');

    return regex.test(value);
};
